import React from 'react';

import { Tag, Typography } from 'antd';

import { constants } from 'helpers/constants';
import type IProduct from 'interfaces/IProduct';
import { CHECKOUT_ELEMENTS_URL } from 'settings';

import { Icon } from '@eduzz/ui-antd-theme';

import ClipboardField from '../../ClipboardField';

interface IProps {
  currentProduct: IProduct;
  currentUserId: number;
  physicalProductPending: boolean;
}

const CheckoutLink = ({ currentProduct, currentUserId, physicalProductPending }: IProps) => {
  const productId = currentProduct.hash ?? currentProduct.id;
  const isAffiliated = currentProduct.producer_id !== currentUserId;
  const urlCustomizeCheckout = `${constants.links.CustomizeCheckout}?productId=${currentProduct.id}`;
  const urlCheckout = `${CHECKOUT_ELEMENTS_URL}/${productId}${isAffiliated ? `?a=${currentUserId}` : ''}`;

  if (physicalProductPending) {
    return null;
  }

  return (
    <div className='flex w-full flex-col gap-2'>
      <div className='flex flex-wrap items-center gap-2'>
        <Typography.Title level={5} className='!mb-0'>
          Eduzz Checkout Elements
        </Typography.Title>
        <Tag color='success' className='m-0 max-sm:hidden'>
          Novidade
        </Tag>
      </div>

      <div className='flex flex-col gap-2 sm:flex-row sm:items-center'>
        <div className='w-full max-w-md'>
          <ClipboardField value={currentProduct ? urlCheckout : ''} />
        </div>
        <Typography.Link
          href={urlCustomizeCheckout}
          className='inline-flex shrink-0 items-center gap-1'
          target='_blank'
          rel='noreferrer'
        >
          Personalizar Checkout <Icon.ArrowRight size={16} />
        </Typography.Link>
      </div>

      <Typography.Paragraph className='text-content-subtitle !mb-0'>
        O Eduzz Checkout Elements é mais rápido e seguro e tem uma taxa de conversão até 10% superior
      </Typography.Paragraph>
    </div>
  );
};

export default CheckoutLink;
